import Task from './Task';

export type PlanningSessionActivityStep = {
  id: number;
  name: string;
  status: boolean;
  createdAt: Date;
  updatedAt: Date;
  planningSessionActivityGroupId: number | null;
};

export type PlanningSessionActivityGroup = {
  id: number;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  planningSessionId: number;
  PlanningSessionActivitySteps: PlanningSessionActivityStep[];
};

export type PlanningSessionType = {
  id: number;
  name: string;
  description: string | null;
  nextSprintName: string | null;
  status: string;
  createdAt: Date;
  updatedAt: Date;
  createdBy: number;
  workspaceId: number;
  PlanningSessionActivityGroups: PlanningSessionActivityGroup[];
};

export type TimerConfiguration = {
  createdAt: number | null;
  startedAt: number | null;
  stoppedAt: number | null;
  duration: number;
  totalSecondsPassed: number | null;
  status: 'paused' | 'active';
};

export enum PlanningSessionStatus {
  // PLANNING_NOT_STARTED = 'PLANNING_NOT_STARTED', // TODO: Consider removing this state
  PLANNING_IN_PROGRESS = 'PLANNING_IN_PROGRESS',
  PLANNING_COMPLETED = 'PLANNING_COMPLETED',
  PLANNING_CANCELED = 'PLANNING_CANCELED',
}

export default PlanningSessionType;
